export default function FAQ() {
    return (
        <div>
            <h1>Foire aux questions et remarques</h1>
            <p>Adresse, parking, horaires, dress code…</p>
        </div>
    );
}

